import api from '@/services/api'

const state = {
    columns: [],
    values: {}
  }
  const getters = {}

  const actions = {
    loadColumns({ commit }) {
        return new Promise((resolve) => {
            api().get(`/elastic/fields`).then( (response) => {
              const cols = response.data.data;
              commit('setColumns', cols);
              resolve(cols);
            })
          })
    },
    loadValues({ commit, state }, field) {
        return new Promise((resolve) => {
            if(state.values[field])
                return state.values[field];

            api().get(`/elastic/values/${field}`).then( (response) => {
              const v = response.data.data;
              commit('setValues', [ field, v ]);
              resolve(v);
            })
          })
    }
  }

  const mutations = {
    setColumns(state, cols) {
        state.columns = cols;
    },
    setValues(state, data) {
        state.values[ data[0] ] = data[1];
    }
  }

  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  }



// WEBPACK FOOTER //
// ./src/store/modules/elastic.js